/**
 * @generated SignedSource<<ab0f93cd8c72e73c564c047515e5c2d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InfoSubscription$variables = {
  screenId: string;
};
export type InfoSubscription$data = {
  readonly storecastScreenInfoChange: {
    readonly " $fragmentSpreads": FragmentRefs<"InfoBoxScreen_StorecastScreen">;
  } | null;
};
export type InfoSubscription = {
  response: InfoSubscription$data;
  variables: InfoSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "screenId",
    "variableName": "screenId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InfoSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InfoBoxScreen_StorecastScreen"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InfoSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastDeviceInfo",
            "kind": "LinkedField",
            "name": "info",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languageStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolutionStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "time",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZoneStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userAgentStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "266cecf5b24fdd6ba0d6a5c50d92eeab",
    "id": null,
    "metadata": {},
    "name": "InfoSubscription",
    "operationKind": "subscription",
    "text": "subscription InfoSubscription(\n  $screenId: ID!\n) {\n  storecastScreenInfoChange(screenId: $screenId) {\n    ...InfoBoxScreen_StorecastScreen\n    id\n  }\n}\n\nfragment InfoBoxScreen_StorecastScreen on StorecastScreen {\n  id\n  info {\n    language\n    languageStatus\n    resolution\n    resolutionStatus\n    time\n    timeStatus\n    timeZone\n    timeZoneStatus\n    userAgentStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "1daedb9aec7df71e87430b04dc329b63";

export default node;
